import React from 'react';
import './MoonPhaseIcon.css';

const MoonPhaseIcon = ({ phase, size = 40 }) => {
  const getMoonPath = () => {
    switch (phase) {
      case 'New Moon':
        return (
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="#2c2820"
            stroke="#6b5644"
            strokeWidth="2"
          />
        );

      case 'Waxing Crescent':
        return (
          <>
            <circle cx="50" cy="50" r="45" fill="#2c2820" stroke="#6b5644" strokeWidth="2" />
            <path
              d="M 50,5 A 45,45 0 0,1 50,95 A 30,45 0 0,0 50,5"
              fill="#f5e6d3"
              opacity="0.9"
            />
          </>
        );

      case 'First Quarter':
        return (
          <>
            <circle cx="50" cy="50" r="45" fill="#2c2820" stroke="#6b5644" strokeWidth="2" />
            <path
              d="M 50,5 A 45,45 0 0,1 50,95 L 50,5"
              fill="#f5e6d3"
              opacity="0.9"
            />
          </>
        );

      case 'Waxing Gibbous':
        return (
          <>
            <circle cx="50" cy="50" r="45" fill="#2c2820" stroke="#6b5644" strokeWidth="2" />
            <path
              d="M 50,5 A 45,45 0 0,1 50,95 A 20,45 0 0,1 50,5"
              fill="#f5e6d3"
              opacity="0.9"
            />
          </>
        );

      case 'Full Moon':
        return (
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="#f5e6d3"
            stroke="#6b5644"
            strokeWidth="2"
          />
        );

      case 'Waning Gibbous':
        return (
          <>
            <circle cx="50" cy="50" r="45" fill="#f5e6d3" stroke="#6b5644" strokeWidth="2" />
            <path
              d="M 50,5 A 45,45 0 0,1 50,95 A 20,45 0 0,0 50,5"
              fill="#2c2820"
              opacity="0.9"
            />
          </>
        );

      case 'Last Quarter':
        return (
          <>
            <circle cx="50" cy="50" r="45" fill="#f5e6d3" stroke="#6b5644" strokeWidth="2" />
            <path
              d="M 50,5 A 45,45 0 0,1 50,95 L 50,5"
              fill="#2c2820"
              opacity="0.9"
            />
          </>
        );

      case 'Waning Crescent':
        return (
          <>
            <circle cx="50" cy="50" r="45" fill="#f5e6d3" stroke="#6b5644" strokeWidth="2" />
            <path
              d="M 50,5 A 45,45 0 0,1 50,95 A 30,45 0 0,1 50,5"
              fill="#2c2820"
              opacity="0.9"
            />
          </>
        );

      default:
        return (
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="#f5e6d3"
            stroke="#6b5644"
            strokeWidth="2"
          />
        );
    }
  };

  return (
    <svg
      className="moon-phase-icon"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Crater details for texture */}
      <defs>
        <filter id="moonTexture">
          <feTurbulence baseFrequency="0.05" numOctaves="2" />
          <feColorMatrix values="0 0 0 0 0.8  0 0 0 0 0.8  0 0 0 0 0.8  0 0 0 0.1 0" />
        </filter>
      </defs>

      {/* Main moon shape */}
      {getMoonPath()}

      {/* Subtle texture overlay */}
      <circle
        cx="50"
        cy="50"
        r="45"
        fill="none"
        stroke="rgba(0, 0, 0, 0.1)"
        strokeWidth="1"
        filter="url(#moonTexture)"
        opacity="0.3"
      />

      {/* Add a few crater details */}
      {(phase && (phase === 'Full Moon' || phase.includes('Gibbous') || phase.includes('Quarter'))) && (
        <>
          <circle cx="35" cy="35" r="6" fill="rgba(0, 0, 0, 0.15)" />
          <circle cx="65" cy="45" r="4" fill="rgba(0, 0, 0, 0.12)" />
          <circle cx="45" cy="60" r="5" fill="rgba(0, 0, 0, 0.13)" />
        </>
      )}
    </svg>
  );
};

export default MoonPhaseIcon;
